import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState } from 'react';
import { Flex, Grid } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
import { VirtualTable } from '../../../../tables';
import { Input, Select } from '../../../../inputs';
const VisiblePropsDialogFC = ({ config, excludeIds, onChangeExcludeIds }) => {
    const [query, setQuery] = useState('');
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const { t } = useT();
    const isQueryOrGroup = !query || !selectedGroupId;
    const filteredPropsByGroup = selectedGroupId
        ? config.availableProps.filter((item) => item.groupId === selectedGroupId)
        : config.availableProps;
    const filteredPropsByGroupAndName = filteredPropsByGroup.filter((item) => item.name.toLowerCase().includes(query.toLowerCase()));
    const groupsOptions = [
        { value: '', label: t('jsfields.VisibleProps.allGroups') },
        ...config.availableGroups.map((group) => ({
            value: group.groupId,
            label: group.name
        }))
    ];
    const columns = [{ name: t('jsfields.VisibleProps.name') }];
    const rows = filteredPropsByGroupAndName.map(({ id, name }) => ({
        key: id,
        values: [name],
        isDisabled: false,
        isSelected: !excludeIds.includes(id)
    }));
    const handleSelectAll = () => {
        if (!isQueryOrGroup) {
            onChangeExcludeIds([]);
        }
        else {
            const shownIds = filteredPropsByGroupAndName.map((p) => p.id);
            onChangeExcludeIds(excludeIds.filter((id) => !shownIds.includes(id)));
        }
    };
    const handleUnSelectAll = () => {
        if (!isQueryOrGroup) {
            onChangeExcludeIds(config.availableProps.map((p) => p.id));
        }
        else {
            const shownIds = filteredPropsByGroupAndName.map((p) => p.id);
            onChangeExcludeIds([...new Set([...excludeIds, ...shownIds])]);
        }
    };
    return (_jsxs(Flex, { flexDirection: "column", w: "300px", gap: "8px", children: [_jsxs(Grid, { gridTemplateColumns: "1fr 1fr", gap: "4px", children: [_jsx(Input, { size: "xs", variant: "outline", value: query, placeholder: t('actions.search'), onChange: setQuery }), _jsx(Select, { name: "VisibleProps_Group", options: groupsOptions, value: groupsOptions.find((opt) => opt.value === selectedGroupId), onChange: (option) => setSelectedGroupId(option.value) })] }), _jsx(VirtualTable, { isCheckboxShown: true, columns: columns, rows: rows, tableSx: { height: 300 }, noItemsTitle: t('jsfields.VisibleProps.noProps'), onSelectAll: handleSelectAll, onUnselectAll: handleUnSelectAll, onSelect: (value) => {
                    onChangeExcludeIds(excludeIds.filter((id) => id !== value));
                }, onUnselect: (value) => {
                    onChangeExcludeIds([...excludeIds, value]);
                } })] }));
};
export const VisiblePropsDialog = memo(VisiblePropsDialogFC);
//# sourceMappingURL=VisiblePropsDialog.js.map